module.exports = __webpack_public_path__ + "static/automation-kr-mobile-42e5dc178df165bc11e58aece47bb596.png";